import React, { useState } from 'react';

interface ComboboxProps {
  options: { id: string; value: string }[];
  onSelect: (option: { id: string; value: string }) => void;
  placeholder?: string;
  ref?: React.RefObject<HTMLInputElement>;
  value?: string;
  error?: string;
}

const Combobox: React.FC<ComboboxProps> = ({
  options,
  onSelect,
  placeholder,
  ref,
  value,
  error,
}) => {
  const [searchTerm, setSearchTerm] = useState(value || '');
  const [isOpen, setIsOpen] = useState(false);

  const filteredOptions = options.filter((option) =>
    option.value.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleSelect = (option: { id: string; value: string }) => {
    onSelect(option);
    setSearchTerm(option.value);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onFocus={() => setIsOpen(true)}
        // onBlur={() => setIsOpen(false)}
        className={`border-input placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border ${
          error ? 'border-red-500' : 'border-primary-light'
        } bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50`}
        placeholder={placeholder}
        ref={ref}
      />
      {error && <p className="text-sm text-red-500">{error}</p>}
      {isOpen && (
        <ul className="absolute z-10 mt-1 max-h-60 w-full overflow-y-auto rounded-md border border-gray-300 bg-white">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <li
                key={option.id}
                onClick={() => handleSelect(option)}
                className="cursor-pointer px-3 py-2 hover:bg-gray-100 sm:text-xs md:text-sm"
              >
                {option.value}
              </li>
            ))
          ) : (
            <li className="cursor-default px-3 py-2 text-gray-500">
              No data found
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default Combobox;
